// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"d62ce916","339":"20355705","453":"f7be5b23"}[chunkId] + ".chunk.js";
};